import { Flame } from "lucide-react";

/** "3× enquired" badge for leads that enquired more than once (enquiry_count = repeats). */
export function EnquiryBadge({ lead, className = "" }) {
  const n = (lead?.enquiry_count || 0) + 1;
  if (n < 2) return null;
  const last = (lead.enquiries || []).slice(-1)[0];
  return (
    <span title={last ? `Last enquiry via ${last.source}${last.campaign ? ` · ${last.campaign}` : ""}` : "Enquired more than once"}
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-orange-100 text-orange-700 text-[10px] font-bold whitespace-nowrap ${className}`}
      data-testid={`enquiry-badge-${lead.id}`}>
      <Flame className="w-3 h-3" />{n}× enquired
    </span>
  );
}
